import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { common } from '@/app/utils'
import { Loader } from '@/shared'
import { routes } from '@Config/config'

import { BLANK_VALUE } from '../../../helper'
import { EmptyContent } from '../../EmptyContent/EmptyContent'
import { Pagination } from '../../Pagination'

import { Filters } from './Filters/Filters'
import style from './List.module.scss'

export const List = observer(() => {
    const navi = useNavigate()

    const headers = [
        'Маркер',
        'ФИО',
        'Дата рождения',
        'Страховая компания',
        'Полис',
        'Дата прикрепления',
        'Дата открепления',
        'Дата окончания полиса'
    ]

    const onGetChosenPage = (chosenPage: number) => {
        dmsState.onSetInsuredFilters({ ...dmsState.insuredFilters, skip: chosenPage })
        dmsState.onGetInsuredsList()
    }

    const onGetPrevPage = () => {
        dmsState.onSetInsuredFilters({
            ...dmsState.insuredFilters,
            skip: dmsState.insuredFilters.skip - dmsState.insuredFilters.top
        })
        dmsState.onGetInsuredsList()
    }

    const onGetNextPage = () => {
        dmsState.onSetInsuredFilters({
            ...dmsState.insuredFilters,
            skip: dmsState.insuredFilters.skip + dmsState.insuredFilters.top
        })
        dmsState.onGetInsuredsList()
    }

    if (!dmsState.insuredsList || !dmsState.companiesList) {
        return <Loader className={style.loader} />
    }

    return (
        <div className={style.container}>
            {dmsState.insuredsList && (
                <div className={style.actions}>
                    <button className={style.btn} onClick={() => navi(`${routes.DMSM}/insureds/addInsured`)}>
                        Добавить пациента
                    </button>
                </div>
            )}
            {dmsState.insuredsList && <Filters />}
            {dmsState.insuredsList.length === 0 && (
                <EmptyContent
                    title='Список застрахованных пациентов пуст'
                    action={{
                        title: 'Добавить первого пациента',
                        callback: () => navi(`${routes.DMSM}/insureds/addInsured`)
                    }}
                />
            )}
            {dmsState.insuredsList.length > 0 && (
                <>
                    <div className={style.headerLineWrapper}>
                        {headers.map((title) => (
                            <div key={title} className={style.headerLine}>
                                <div className={style.headerCell}>
                                    <span>{title}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    {dmsState.insuredsList.map((line) => {
                        const {
                            id,
                            f,
                            i,
                            o,
                            birthDate,
                            insuranceCompanyName,
                            polisNumber,
                            polisStartedAt,
                            polisFinishedAt,
                            expirationDate,
                            identificationMarkers
                        } = line

                        // const onHandleClick = () => onGetChosenInsured(id)
                        const onHandleClick = () => navi(`${routes.DMSM}/insureds/${id}`)

                        return (
                            <div key={id} className={style.lineWrapper} onClick={onHandleClick}>
                                <div className={style.line}>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <div className={style.statusWrapper}>
                                            {identificationMarkers.map((marker, idx) => {
                                                const { code } = marker
                                                return (
                                                    <div
                                                        key={idx}
                                                        className={style.status}
                                                        style={{ background: code }}
                                                    />
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className={classNames(style.cell, style.cellLong)}>
                                        <span>
                                            {common.fioHandler({ fname: f, iname: i, oname: o }, 'lastnameAndInitials')}
                                        </span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <span>{moment(birthDate).format('DD.MM.YYYY')}</span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellLong)}>
                                        <span>{insuranceCompanyName}</span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <span>{polisNumber}</span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <span>
                                            {polisStartedAt
                                                ? moment(polisStartedAt).utc().format('DD.MM.YYYY')
                                                : BLANK_VALUE}
                                        </span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <span>
                                            {polisFinishedAt
                                                ? moment(polisFinishedAt).utc().format('DD.MM.YYYY')
                                                : BLANK_VALUE}
                                        </span>
                                    </div>
                                    <div className={classNames(style.cell, style.cellCentered)}>
                                        <span>{moment(expirationDate.split('T')[0]).format('DD.MM.YYYY')}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <Pagination
                        onGetNextPage={onGetNextPage}
                        onGetPrevPage={onGetPrevPage}
                        onGetPage={onGetChosenPage}
                    />
                </>
            )}
        </div>
    )
})
